export default "__VITE_ASSET__BnGpZQ2G__"